// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';

// type
import { OrderType } from 'types/order';

const AffilisTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'affilis';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const orderCode = order ? (order as OrderType).order_code : '';
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? `
      var _CIDN = "cid";
      var _PMTV = "59d3450c223de";
      var _ARGS = "${orderCode}";
      var _TRKU = "https://afl.affilis.biz/track.php?p=" + _PMTV + "&t=59d3450c&args=" + _ARGS;
      var _cks = document.cookie.split("; ");
      var _cidv = "";
      for(var i = 0; i < _cks.length; i++){ var _ckd = _cks[i].split( "=" ); if(_ckd[0] == "CL_" + _PMTV && _ckd[1].length > 1){ _cidv = _ckd[1]; break; }}
      if(!_cidv && localStorage.getItem("CL_" + _PMTV)){ _cidv = localStorage.getItem("CL_" + _PMTV); }
      if(_cidv){ _TRKU += "&" + _CIDN + "=" + _cidv; }
      img = document.body.appendChild(document.createElement("img"));
      img.src = _TRKU;
      `
      : ``;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default AffilisTag;
